import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  test: {
    '& .MuiTabs-root': {
      zIndex: 14
    }
  },
  mdSelector: {
    width: '555px'
  },
  smSelector: {
    width: '190px',
    marginLeft: '10px'
  },
  customPeriodSelector: {
    width: '245px',
    marginLeft: '10px',
    '& .MuiFormControl-root': {
      minWidth: '200px'
    }
  },
  selectors: {
    position: 'relative',
    zIndex: '15',
    marginTop: '40px'
  },
  chartHeader: {
    padding: '18px',
    background: palette.gradients.white,
    display: 'flex',
    justifyContent: 'space-between'
  },
  chartHeaderV2: {
    padding: '18px',
    display: 'flex',
    justifyContent: 'center'
  },
  chartContainer: {
    height: '475px'
  },
  chartContainerV2: {
    minHeight: '290px'
  },
  chartContent: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  chartContentPie: {
    height: '250px'
  },
  soloChartHeader: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  },
  soloChartHeaderItem: {
    margin: 0
  },
  soloChartContent: {
    display: 'block',
    // width: '102.6%',
    width: '100',
    alignItems: 'center',
    justifyContent: 'center'
  },
  arrow: {
    transition: "all ".concat(palette.transitions.short)
  },
  arrowIsOpen: {
    transform: 'rotate(-180deg)'
  },
  collapseTable: {
    padding: '0',
    borderBottom: '0',
    '&:first-of-type': {
      paddingLeft: '0'
    },
    '&:last-of-type': {
      paddingRight: '0'
    },
    '& .MuiTableRow-root': {
      backgroundColor: palette.shades[200],
      '& + .MuiTableRow-root': {
        borderTop: "1px solid ".concat(palette.shades[300])
      }
    }
  },
  sendReminderToAllTrigger: {
    marginLeft: '10px'
  },
  collapseIsOpen: {
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  unitCell: {
    width: '50px',
    minWidth: '50px'
  },
  tooltipCellSm: {
    maxWidth: '300px',
    width: '300px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  residentCell: {
    maxWidth: '250px',
    width: '250px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  addressHeaderCell: {
    maxWidth: '550px',
    width: '550px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  addressCell: {
    maxWidth: '230px',
    width: '230px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  contactsCell: {
    maxWidth: '230px',
    width: '230px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& .MuiTypography-root': {
      color: palette.primary.main,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  debtPeriodCell: {
    maxWidth: '140px',
    minWidth: '100px',
    width: '140px'
  },
  residentTotal: {
    color: palette.error.main
  },
  tableContainer: {
    boxShadow: 'none',
    border: "1px solid ".concat(palette.shades[300])
  },
  periodCell: {
    width: '130px',
    maxWidth: '130px'
  },
  totalCell: {
    width: '100px',
    maxWidth: '100px'
  },
  actionCell: {
    width: '150px',
    maxWidth: '150px'
  },
  emptyPlaceholder: {
    height: '466px',
    border: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderTop: 'none',
    borderRadius: '0 0 2px 2px'
  },
  emptyPlaceholderSingleChart: {
    height: '254px',
    maxHeight: '254px',
    border: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderTop: 'none',
    borderRadius: '0 0 2px 2px'
  },
  emptyPlaceholderSingleChartV2: {
    height: '254px',
    maxHeight: '254px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderTop: 'none',
    borderRadius: '0 0 2px 2px'
  },
  reimbursementTabSummary: {
    display: 'flex',
    justifyContent: 'space-between',
    border: "1px solid ".concat(palette.shades[300]),
    padding: '16px 24px 16px 24px'
  },
  inlineTooltip: {
    padding: '0',
    height: '24px',
    '& .MuiButtonBase-root': {
      height: '24px'
    }
  },
  reimbursementTabGraphHeader: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '20px',
    marginBottom: '15px',
    '& .MuiToggleButtonGroup-root': {
      marginLeft: '20px'
    }
  },
  arTooltipContainer: {
    minWidth: '220px'
  },
  arTooltip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 0',
    '& .MuiSvgIcon-root': {
      marginRight: '10px'
    }
  },
  arTooltipRowValue: {
    color: palette.error.main
  },
  arTooltipTotal: {
    borderTop: "1px solid ".concat(palette.shades[400]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'unset',
    padding: '8px 18px 8px 18px'
  },
  arReportAction: {
    '& .arReportActionDownloadReport': {
      marginRight: '8px',
      minWidth: '100px'
    },
    '& .modal-trigger:not(:last-child)': {
      marginRight: '8px',
      minWidth: '100px'
    }
  }
}));
export default useStyles;